const model = {
  formOptions: {},
  formValue: null,
};

export default model;
